import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter
} from '@angular/core';

import { Observable, Subject, timer, merge } from 'rxjs';
import { tap, map, takeWhile, filter } from 'rxjs/operators';

const toUTC = (date: Date): number => {
    return Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    );
};

const TIMER_INTERVAL = 200;

@Component({
    selector: 'app-time-left',
    templateUrl: './time-left.component.pug',
    styleUrls: ['./time-left.component.less']
})
export class TimeLeftComponent implements OnInit {

    @Input() startTime: number = new Date() .getTime();
    @Input() endTime: number;
    @Input() format: string;

    @Output() end: EventEmitter<any> = new EventEmitter();

    private _timeSbj: Subject<number> = new Subject();
    public timeLeft$: Observable<number> = this._timeSbj.asObservable();

    constructor() {
    }

    ngOnInit() {
        if (this.startTime < this.endTime) {
            this.startTimer();
        }
    }

    startTimer() {
        const timer$ = timer(0, TIMER_INTERVAL)
            .pipe(map(() => toUTC(new Date())));

        const timeLeft$ = timer$
            .pipe(filter((now) => now >= this.startTime))
            .pipe(map((now) => this.endTime - now))
            .pipe(map((timeLeft) => timeLeft > TIMER_INTERVAL ? timeLeft : 0))
            .pipe(tap((timeLeft) => this._timeSbj.next(timeLeft)));

        timeLeft$
            .pipe(takeWhile((timeLeft) => timeLeft > 0))
            .subscribe(() => {}, () => {}, () => {
                this.end.emit();
            });
        }

}
